import { useState, useCallback, useMemo } from "react";

const useAdvancedSorting = (releases = [], initialSortBy = "releaseDate") => {
    const [sortBy, setSortBy] = useState(initialSortBy);

    // Sort functions
    const sortFunctions = useMemo(() => ({
        
        releaseDate: (a, b) => {
            const dateA = new Date(a.releaseDate);
            const dateB = new Date(b.releaseDate);
            return dateA - dateB;
        },
        
        rating: (a, b) => {
            // Handle null ratings - put them at the end
            if (a.rating === null && b.rating === null) return 0;
            if (a.rating === null) return 1;
            if (b.rating === null) return -1;
            
            // Sort by rating descending
            if (a.rating !== b.rating) {
                return b.rating - a.rating;
            }
            
            // Secondary sort by release date ascending
            const dateA = new Date(a.releaseDate);
            const dateB = new Date(b.releaseDate);
            return dateA - dateB;
        },
        
        title: (a, b) => {
            // Alphabetical sort by title
            const titleA = a.title?.toLowerCase() || "";
            const titleB = b.title?.toLowerCase() || "";
            
            if (titleA < titleB) return -1;
            if (titleA > titleB) return 1;
            
            // Secondary sort by release date ascending
            const dateA = new Date(a.releaseDate);
            const dateB = new Date(b.releaseDate);
            return dateA - dateB;
        }
    }), []);

    // Apply sorting
    const sortedReleases = useMemo(() => {
        if (!releases || releases.length === 0) return [];
        
        const sortFunction = sortFunctions[sortBy];
        if (!sortFunction) return releases;
        
        // Create a copy to avoid mutating the original array
        return [...releases].sort(sortFunction);
    }, [releases, sortBy, sortFunctions]);

    // Handle sort change
    const handleSortChange = useCallback((newSortBy) => {
        setSortBy(newSortBy);
    }, []);

    // Get available sort options
    const sortOptions = useMemo(() => [
        { value: "releaseDate", label: "Release date", description: "Earliest releases first" },
        { value: "rating", label: "Rating", description: "Highest rated first" },
        { value: "title", label: "Title", description: "Alphabetical order" },
    ], []);

    return {
        // Sorted data
        sortedReleases,
        
        // Sort state
        sortBy,
        setSortBy,
        handleSortChange,
        
        // Available options
        sortOptions,
    };
};

export default useAdvancedSorting;